import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  resolvePostLoginDestination,
  DEFAULT_APP_HOME,
  consumePostLoginRedirect,
  isMarketingSitePath,
  isOnboardingCompleteLocally,
} from '../../config/routes';
import AuthContext from './AuthContext';

const AuthValidation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  useEffect(() => {
    if (isLoading) return;

    const path = location.pathname;
    const onboardingDone = isOnboardingCompleteLocally();

    if (isAuthenticated && path === '/onboarding' && onboardingDone) {
      navigate(DEFAULT_APP_HOME, { replace: true });
      return;
    }

    if (isAuthenticated && isMarketingSitePath(path)) {
      navigate(onboardingDone ? DEFAULT_APP_HOME : '/onboarding', { replace: true });
      return;
    }

    if (isAuthenticated && path === '/login') {
      const params = new URLSearchParams(location.search);
      const fromQuery = params.get('redirect');
      const target = resolvePostLoginDestination(
        fromQuery || consumePostLoginRedirect() || sessionStorage.getItem('lastVisitedPage') || DEFAULT_APP_HOME
      );
      navigate(target, { replace: true });
    }
  }, [location.pathname, location.search, isAuthenticated, isLoading, navigate]);

  return null;
};

export default AuthValidation;
